import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAppointmentStatuses } from '../../../hooks/appointments/useAppointmentStatuses';

export default function AppointmentStatusSelect ({ onSelect, statusId, disabledOptions=[] }) {

    const {statuses, loading} = useAppointmentStatuses();

    const handleChange = (e) => {
      onSelect(e.target.value);
    };

    return (
        <React.Fragment>
          <FormControl fullWidth>
            <InputLabel>
              Select Status
            </InputLabel>
            <Select
              value={statusId}
              label="Select Status"
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250, // adjust as needed
                  },
                },
              }}
            >
              {!loading && statuses?.map((status) => (
                !disabledOptions.includes(status.id) ? <MenuItem value={status.id} sx={{ my: 1 }}>{status.name}</MenuItem> : null
              ))}
            </Select>
          </FormControl>
        </React.Fragment>
    );
}